import React from 'react';

import { FormatAlignCenterOutlined, FormatAlignLeftOutlined, FormatAlignRightOutlined } from '@mui/icons-material';
import { ToggleButton } from '@mui/material';

import ToolbarToggleInput from '../base/ToolbarToggleInput';

type Props = {
  label: string;
  name: string;
};
export default function TextAlign({ label, name }: Props) {
  return (
    <ToolbarToggleInput label={label} name={name}>
      <ToggleButton value="left">
        <FormatAlignLeftOutlined fontSize="small" />
      </ToggleButton>
      <ToggleButton value="center">
        <FormatAlignCenterOutlined fontSize="small" />
      </ToggleButton>
      <ToggleButton value="right">
        <FormatAlignRightOutlined fontSize="small" />
      </ToggleButton>
    </ToolbarToggleInput>
  );
}
